<template>
  <div class="sbc-card">
    <div class="sbc-card__head">
      <div class="sbc-card__title">{{ $t('topCustomers') }}</div>
    </div>
    <div
      v-if="canSee"
      class="sbc-card__list"
    >
      <div
        v-for="item in items"
        :key="item.customer_id || item.customer_name"
        class="sbc-card__row"
      >
        <span
          v-if="avatarSrc(item)"
          class="sbc-card__avatar"
        >
          <img
            :src="avatarSrc(item)"
            alt=""
          >
        </span>
        <span
          v-else
          class="sbc-card__avatar sbc-card__avatar--fallback"
        >
          {{ initials(item.customer_name) }}
        </span>
        <span class="sbc-card__name">{{ item.customer_name }}</span>
        <span class="sbc-card__amount">
          {{ $numberFormat(item.amount) }}
          {{ $store.state.currency.name }}
        </span>
      </div>
      <div
        v-if="loading"
        class="sbc-card__more"
      >
        <v-progress-circular
          :width="3"
          color="blue"
          indeterminate
          size="22"
        />
      </div>
      <div
        v-else-if="!items.length"
        class="sbc-card__empty"
      >
        <home-empty-state />
      </div>
    </div>
    <div
      v-else
      class="sbc-card__empty"
    >
      {{ $t("you don't have access to this information") }}
    </div>
  </div>
</template>

<script>
import HomeEmptyState from './HomeEmptyState.vue'

export default {
  name: 'HomeSalesByCustomer',
  components: { HomeEmptyState },
  props: {
    dateType: {
      type: String,
      default: '7days'
    }
  },
  data () {
    return {
      items: [],
      loading: false
    }
  },
  computed: {
    canSee () {
      return this.$store.getters.getpermission && this.$store.getters.getpermission.includes('overview')
    }
  },
  watch: {
    dateType () {
      this.fetchList()
    }
  },
  mounted () {
    this.fetchList()
  },
  methods: {
    initials (name) {
      const parts = String(name || '').trim().split(/\s+/).filter(Boolean)
      if (!parts.length) return '—'
      if (parts.length === 1) return parts[0].slice(0, 2)
      return parts[0].charAt(0) + parts[1].charAt(0)
    },
    avatarSrc (item) {
      const avatar = item && item.avatar
      if (!avatar) return ''
      if (typeof avatar === 'string') return avatar
      return avatar.link || avatar.url || ''
    },
    extractList (payload) {
      const root = payload && payload.data ? payload.data : payload
      const sell = root && root.topCustomers && root.topCustomers.sell
      if (Array.isArray(sell)) return sell
      if (Array.isArray(root)) return root
      return []
    },
    fetchList () {
      this.loading = true
      this.$axios.get(this.$endpoint + 'dashboard/charts/top-customers', {
        params: {
          dateType: this.dateType
        }
      }).then(res => {
        const list = this.extractList(res.data).slice()
        list.sort((a, b) => (parseFloat(b.amount) || 0) - (parseFloat(a.amount) || 0))
        this.items = list.slice(0, 10)
      }).catch(() => {
        this.items = []
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style scoped>
.sbc-card {
  background: #fff;
  border: 1px solid #E5E7EB;
  border-radius: 4px;
  padding: 12px 14px;
  height: 262px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.sbc-card__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
  flex-shrink: 0;
}
.sbc-card__title {
  font-size: 13px;
  font-weight: 700;
  color: #111;
}
.sbc-card__list {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
}
.sbc-card__list::-webkit-scrollbar {
  width: 4px;
}
.sbc-card__list::-webkit-scrollbar-thumb {
  background: #D1D5DB;
  border-radius: 4px;
}
.sbc-card__row {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 0;
  border-bottom: 1px solid #F3F4F6;
}
.sbc-card__row:last-child {
  border-bottom: none;
}
.sbc-card__avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
  background: #F3F4F6;
}
.sbc-card__avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.sbc-card__avatar--fallback {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  color: #6B7280;
}
.sbc-card__name {
  flex: 1 1 auto;
  min-width: 0;
  font-size: 12px;
  color: #111;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.sbc-card__amount {
  flex-shrink: 0;
  font-size: 12px;
  color: #111;
  white-space: nowrap;
}
.sbc-card__empty {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #6B7280;
  text-align: center;
  min-height: 0;
}
.sbc-card__more {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 0;
}
</style>
